import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const RelatedProject = ({ currentProjectId }) => {
  const [projects, setProjects] = useState([]);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    const fetchRelatedProjects = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/projects-list`);
        const data = await response.json();
        const filtered = data
          .filter((p) => p.id !== currentProjectId)
          .slice(0, 3);
        setProjects(filtered);
      } catch (error) {
        console.error("Error fetching related projects:", error);
      }
    };

    fetchRelatedProjects();
  }, [currentProjectId, apiUrl]);

  if (projects.length === 0) {
    return <p>No related projects found.</p>;
  }

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="wpo-project-single-item related-project">
      <div
        className="wpo-project-single-title"
        style={{
          marginBottom: "30px",
          padding: "15px 40px",
          borderRadius: "10px",
          color: "#fff",
          boxShadow: "0 0 40px 5px rgba(0, 0, 139, 0.25)",
        }}
      >
        <h3>Related Projects</h3>
      </div>
      <div
        className="wpo-project-section-s4"
        style={{
          paddingTop: "100px",
          borderRadius: "20px",
        }}
      >
        <div className="row">
          <div className="col col-xs-12 sortable-project">
            <div className="wpo-project-container">
              <div className="row">
                {projects.slice(0, 3).map((project, pot) => (
                  <div className="col-lg-4 col-md-6 col-12" key={pot}>
                    <div className="grid">
                      <div className="wpo-project-item">
                        <img
                          src={`${apiUrl}/storage/` + project.banner}
                          alt=""
                          style={{
                            width: "100%",
                            height: "220px", // 🔥 fixed image height
                            objectFit: "cover", // keep aspect ratio and crop overflow
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        />
                        <div className="wpo-project-text">
                          <h3>
                            <Link
                              onClick={ClickHandler}
                              to={`/project-single/${project.id}`}
                            >
                              {project.title}
                            </Link>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RelatedProject;
